<template>
  <div class="dynamic-page">
    <div
      class="page-cover"
      :style="photoUrl ? { backgroundImage: 'url(' + photoUrl + ')' } : {}"
    >
      <div class="page-cover__content">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="page-cover__title" v-if="title">{{ title }}</div>
              <div
                class="page-cover__text editor"
                v-if="description"
                v-html="description"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container py-4" v-if="!loading && !title && !description">
      <p class="text-muted">Bu səhifə üçün məzmun hələ təyin edilməyib.</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "dynamic-page",
  data() {
    return {
      loading: true,
      menu: null,
      about: null,
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang;
    },
    title() {
      if (!this.menu) return "";
      const key = "description_" + this.lang;
      return this.menu[key] || this.menu.description_az || "";
    },
    description() {
      if (!this.about) return "";
      const key = "description_" + this.lang;
      const v = this.about[key] || this.about.description_az || "";
      // Təmizlə: HTML entity və real non-breaking space (U+00A0) -> adi boşluq
      return v.replace(/&nbsp;/g, " ").replace(/\u00A0/g, " ");
    },
    photoUrl() {
      return this.about ? this.about.photoUrl : "";
    },
    currentPath() {
      return this.$route.path;
    },
  },
  watch: {
    currentPath() {
      this.loadAll();
    },
  },
  async mounted() {
    await this.loadAll();
  },
  methods: {
    async loadAll() {
      this.loading = true;
      try {
        let menus = this.$store.getters["headerMenus/allMenus"];
        if (!menus || menus.length === 0) {
          await this.$store.dispatch("headerMenus/getHeaderMenus");
          menus = this.$store.getters["headerMenus/allMenus"];
        }

        const path = this.$route.path;
        this.menu =
          (menus || []).find((m) => m.path && m.path === path) || null;

        if (this.menu && this.menu.aboutTypeId) {
          const res = await axios.get("/home/about");
          const abouts =
            (res.data && res.data.data && res.data.data.abouts) || [];
          this.about =
            abouts.find(
              (a) => a.aboutType && a.aboutType.id === this.menu.aboutTypeId
            ) || null;
        } else {
          this.about = null;
        }
      } catch (err) {
        console.error("DynamicPage load error:", err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
